import React from 'react';
import { toast } from 'react-toastify';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { CSVLink } from "react-csv";

import DropDown from '../../../../../components/DropDown/DropDown';
import ReportTypeCard from '../../../../../components/Custom/ReportTypeCard';
import DropDownMultiSelect from '../../../../../components/DropDown/DropDownMultiSelect';
import FullPageLoader from '../../../../../components/Loader/FullPageLoader/FullPageLoader';

import useMonthlyReports from './Hooks/useMonthlyReports';

export default function MonthlyReports() {

    const {
        MONTHS,
        REPORTS,
        filters,
        setFilters,
        refDownloadFile,
        reportData,
        fileName,
        isDownloadingReport,
        handleReportDownload
    } = useMonthlyReports();

    return (
        <div>
            {
                isDownloadingReport
                    ?
                    <FullPageLoader />
                    :
                    <Card className="my-4 mb-xl-0">
                        <CardHeader className="border-0">
                            <h3 className="mb-0 text-muted">
                                <i className="fas fa-file-invoice mr-1"></i> Monthly Reports
                            </h3>
                            <div className="filter-div-bg p-2 mt-3">
                                <div>
                                    <span>Filter: </span>
                                    <DropDownMultiSelect
                                        type="Month"
                                        selectedValues={filters.months.map(each => each.id)}
                                        options={MONTHS.map(each => ({
                                            id: each.id,
                                            name: each.name
                                        }))}
                                        onChange={(e) => setFilters({ ...filters, months: e })}
                                    />
                                    <DropDown
                                        type="Year"
                                        selectedValue={filters.year}
                                        options={[
                                            { id: 2023, name: "2023" },
                                            { id: 2024, name: "2024" },
                                            { id: 2025, name: "2025" },
                                            { id: 2026, name: "2026" },
                                        ]}
                                        onChange={(e) => setFilters({ ...filters, year: e.id })}
                                    />
                                </div>
                            </div>
                        </CardHeader>

                        <CardBody>
                            <button ref={refDownloadFile} className="d-none">
                                <CSVLink
                                    data={reportData?.data ? reportData?.data : []}
                                    headers={reportData?.headers ? reportData?.headers : []}
                                    filename={`${fileName}.csv`}
                                >
                                    Download List <i className="fas fa-file-download ml-1"></i>
                                </CSVLink>
                            </button>
                            <div className="reports-grid">
                                {
                                    REPORTS.map((each, index) => (
                                        <ReportTypeCard
                                            key={index + "_report"}
                                            title={each.name}
                                            description={each.description}
                                            navigateTo={() => filters.months.length
                                                ?
                                                handleReportDownload(index)
                                                :
                                                toast.warn("Months must be selected to generate report!")
                                            }
                                        />
                                    ))
                                }
                            </div>
                        </CardBody>
                    </Card>
            }
        </div>
    )
}